/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActionOwner } from '../models/ActionOwner';
import type { JobProgramMilestone } from '../models/JobProgramMilestone';
import type { JobProgramPaymentStatus } from '../models/JobProgramPaymentStatus';
import type { JobProgramStatus } from '../models/JobProgramStatus';
import type { JobProgramSubmissionOutcome } from '../models/JobProgramSubmissionOutcome';
import type { JobServiceEquipment } from '../models/JobServiceEquipment';
import type { JobsPipelineSummary } from '../models/JobsPipelineSummary';
import type { JobsPipelineSummaryBucket } from '../models/JobsPipelineSummaryBucket';
import type { Market } from '../models/Market';
import type { PaginatedResponse_JobListWithIncentiveAndEligibilityResponse_ } from '../models/PaginatedResponse_JobListWithIncentiveAndEligibilityResponse_';
import type { RebatesPipelineSummary } from '../models/RebatesPipelineSummary';
import type { SortByOptions } from '../models/SortByOptions';
import type { SortDirectionOptions } from '../models/SortDirectionOptions';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class JobRoutesV2Repository {
  /**
   * Fetch Jobs
   * Lists jobs with rebate estimates and eligibility.
   *
   * Contractors see only their own jobs; internal users see jobs across all contractors.
   * Endpoint is paginated and filterable.
   * @returns PaginatedResponse_JobListWithIncentiveAndEligibilityResponse_ Successful Response
   * @throws ApiError
   */
  public static jobRoutesV2FetchJobs({
    isCanceled,
    searchToken,
    watchedJobs,
    hasContractorReadyTasks,
    paymentStatus,
    programId,
    jobProgramStatus,
    jobProgramMilestone,
    equipmentType,
    pipelineBucket,
    opsUserId,
    unclaimed,
    actionOwner,
    contractorId,
    market,
    sealedReview,
    submissionOutcome,
    installCompletionDateFrom,
    installCompletionDateTo,
    pageNumber = 1,
    perPage = 25,
    sortBy = 'install_start_date',
    sortDirection = 'desc',
    authorization,
  }: {
    isCanceled?: (boolean | null),
    searchToken?: (string | null),
    watchedJobs?: (boolean | null),
    hasContractorReadyTasks?: (boolean | null),
    paymentStatus?: (Array<JobProgramPaymentStatus> | null),
    programId?: (Array<string> | null),
    jobProgramStatus?: (Array<JobProgramStatus> | null),
    jobProgramMilestone?: (Array<JobProgramMilestone> | null),
    equipmentType?: (Array<JobServiceEquipment> | null),
    pipelineBucket?: (JobsPipelineSummaryBucket | null),
    opsUserId?: (Array<string> | null),
    unclaimed?: (boolean | null),
    actionOwner?: (Array<ActionOwner> | null),
    contractorId?: (Array<string> | null),
    market?: (Array<Market> | null),
    sealedReview?: (boolean | null),
    submissionOutcome?: (Array<JobProgramSubmissionOutcome> | null),
    installCompletionDateFrom?: (string | null),
    installCompletionDateTo?: (string | null),
    pageNumber?: number,
    perPage?: number,
    sortBy?: SortByOptions,
    sortDirection?: SortDirectionOptions,
    authorization?: string,
  }): CancelablePromise<PaginatedResponse_JobListWithIncentiveAndEligibilityResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/v2',
      headers: {
        'authorization': authorization,
      },
      query: {
        'is_canceled': isCanceled,
        'search_token': searchToken,
        'watched_jobs': watchedJobs,
        'has_contractor_ready_tasks': hasContractorReadyTasks,
        'payment_status': paymentStatus,
        'program_id': programId,
        'job_program_status': jobProgramStatus,
        'job_program_milestone': jobProgramMilestone,
        'equipment_type': equipmentType,
        'pipeline_bucket': pipelineBucket,
        'ops_user_id': opsUserId,
        'unclaimed': unclaimed,
        'action_owner': actionOwner,
        'contractor_id': contractorId,
        'market': market,
        'sealed_review': sealedReview,
        'submission_outcome': submissionOutcome,
        'install_completion_date_from': installCompletionDateFrom,
        'install_completion_date_to': installCompletionDateTo,
        'page_number': pageNumber,
        'per_page': perPage,
        'sort_by': sortBy,
        'sort_direction': sortDirection,
      },
      errors: {
        401: `Unauthorized`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Fetch Jobs Pipeline Summary
   * Returns the count of the current contractor's jobs per pipeline bucket.
   *
   * Takes the same filters as the job list so the counts follow the selected filters.
   * @returns JobsPipelineSummary Successful Response
   * @throws ApiError
   */
  public static jobRoutesV2FetchJobsPipelineSummary({
    watchedJobs,
    hasContractorReadyTasks,
    paymentStatus,
    programId,
    jobProgramStatus,
    jobProgramMilestone,
    equipmentType,
    authorization,
  }: {
    watchedJobs?: (boolean | null),
    hasContractorReadyTasks?: (boolean | null),
    paymentStatus?: (Array<JobProgramPaymentStatus> | null),
    programId?: (Array<string> | null),
    jobProgramStatus?: (Array<JobProgramStatus> | null),
    jobProgramMilestone?: (Array<JobProgramMilestone> | null),
    equipmentType?: (Array<JobServiceEquipment> | null),
    authorization?: string,
  }): CancelablePromise<JobsPipelineSummary> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/v2/jobs-pipeline-summary',
      headers: {
        'authorization': authorization,
      },
      query: {
        'watched_jobs': watchedJobs,
        'has_contractor_ready_tasks': hasContractorReadyTasks,
        'payment_status': paymentStatus,
        'program_id': programId,
        'job_program_status': jobProgramStatus,
        'job_program_milestone': jobProgramMilestone,
        'equipment_type': equipmentType,
      },
      errors: {
        401: `Unauthorized`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Fetch Rebates Pipeline Summary
   * Returns the count of rebates (job programs) per pipeline bucket.
   * @returns RebatesPipelineSummary Successful Response
   * @throws ApiError
   */
  public static jobRoutesV2FetchRebatesPipelineSummary({
    authorization,
  }: {
    authorization?: string,
  }): CancelablePromise<RebatesPipelineSummary> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/v2/rebates-pipeline-summary',
      headers: {
        'authorization': authorization,
      },
      errors: {
        401: `Unauthorized`,
        422: `Validation Error`,
      },
    });
  }
}
